import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './styles.css';

const NeedHelpAdCreation = () => {
  return (
    <div className={css.container}>
      <FormattedMessage id="NeedHelpAdCreation.text" />
      <a
        className={css.linkRequests}
        href="https://help.swimmy.com/hc/es/requests/new"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage id="NeedHelpAdCreation.link" />
      </a>
    </div>
  );
};

export default NeedHelpAdCreation;
